export * from './two-offers-switch-frequency-lock'
